/**
 * CushMama — Shopify OS 2.0 Product Page JavaScript
 * Handles: countdown, gallery, accordions, bundle selection, sticky CTA, lazy loading
 */
(function() {
  'use strict';

  /* ===================
     COUNTDOWN TIMER
     =================== */
  function initCountdown() {
    const el = document.querySelector('[data-cm-countdown]');
    if (!el) return;

    const hoursEl = el.querySelector('[data-cm-hours]');
    const minsEl = el.querySelector('[data-cm-minutes]');
    const secsEl = el.querySelector('[data-cm-seconds]');
    if (!hoursEl || !minsEl || !secsEl) return;

    function tick() {
      const now = new Date();
      const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      let diff = Math.max(0, Math.floor((midnight - now) / 1000));

      const h = String(Math.floor(diff / 3600)).padStart(2, '0');
      const m = String(Math.floor((diff % 3600) / 60)).padStart(2, '0');
      const s = String(diff % 60).padStart(2, '0');

      hoursEl.innerHTML = h + '<span class="cm-countdown__unit">h</span>';
      minsEl.innerHTML = m + '<span class="cm-countdown__unit">m</span>';
      secsEl.innerHTML = s + '<span class="cm-countdown__unit">s</span>';
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ===================
     IMAGE GALLERY
     =================== */
  function initGallery() {
    document.querySelectorAll('[data-cm-gallery]').forEach(function(gallery) {
      const slides = gallery.querySelectorAll('[data-slide-index]');
      const thumbs = gallery.querySelectorAll('[data-cm-thumb]');
      const prevBtn = gallery.querySelector('[data-cm-gallery-prev]');
      const nextBtn = gallery.querySelector('[data-cm-gallery-next]');
      let current = 0;

      function goTo(idx) {
        if (idx < 0) idx = slides.length - 1;
        if (idx >= slides.length) idx = 0;
        slides.forEach(function(s, i) {
          s.style.display = i === idx ? '' : 'none';
          s.classList.toggle('is-active', i === idx);
        });
        thumbs.forEach(function(t, i) {
          t.classList.toggle('is-active', i === idx);
        });
        current = idx;
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

      thumbs.forEach(function(t) {
        t.addEventListener('click', function() {
          goTo(parseInt(t.getAttribute('data-cm-thumb'), 10));
        });
      });

      // Touch swipe support
      let touchStartX = 0;
      const mainArea = gallery.querySelector('.cm-gallery__main');
      if (mainArea) {
        mainArea.addEventListener('touchstart', function(e) {
          touchStartX = e.changedTouches[0].screenX;
        }, { passive: true });
        mainArea.addEventListener('touchend', function(e) {
          const diff = touchStartX - e.changedTouches[0].screenX;
          if (Math.abs(diff) > 50) {
            goTo(diff > 0 ? current + 1 : current - 1);
          }
        }, { passive: true });
      }
    });
  }

  /* ===================
     ACCORDIONS
     =================== */
  function initAccordions() {
    document.querySelectorAll('[data-cm-accordion]').forEach(function(accordion) {
      accordion.querySelectorAll('[data-cm-accordion-trigger]').forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          const item = trigger.closest('.cm-accordion-item');
          const isOpen = item.classList.contains('is-open');

          // Close siblings
          accordion.querySelectorAll('.cm-accordion-item.is-open').forEach(function(openItem) {
            openItem.classList.remove('is-open');
            openItem.querySelector('[data-cm-accordion-trigger]').setAttribute('aria-expanded', 'false');
          });

          // Toggle current
          if (!isOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  /* ===================
     BUNDLE SELECTION
     =================== */
  function initBundles() {
    const bundles = document.querySelectorAll('[data-cm-bundle]');
    if (!bundles.length) return;

    function selectBundle(bundle) {
      // Remove active from all
      bundles.forEach(function(b) { b.classList.remove('is-active'); });
      bundle.classList.add('is-active');

      // Update variant inputs (skip sticky CTA)
      var variantId = bundle.getAttribute('data-variant-id');
      if (variantId) {
        var stickyInput = document.querySelector('[data-cm-sticky-cta] [data-cm-variant-input]');
        document.querySelectorAll('[data-cm-variant-input]').forEach(function(input) {
          if (input !== stickyInput) input.value = variantId;
        });
      }

      // Store quantity on the form for add-to-cart
      var qty = bundle.getAttribute('data-quantity') || '1';
      document.querySelectorAll('[data-cm-form]').forEach(function(form) {
        form.setAttribute('data-cm-quantity', qty);
      });

      // Update price displays on CTA buttons using pre-formatted prices
      var formattedPrice = bundle.getAttribute('data-formatted-price');
      var formattedCompare = bundle.getAttribute('data-formatted-compare');

      // Only update non-sticky CTA price elements
      var stickyEl = document.querySelector('[data-cm-sticky-cta]');
      document.querySelectorAll('.cm-btn__price').forEach(function(el) {
        if (stickyEl && stickyEl.contains(el)) return;
        if (formattedPrice) el.textContent = formattedPrice;
      });
      document.querySelectorAll('.cm-btn__price-old').forEach(function(el) {
        if (stickyEl && stickyEl.contains(el)) return;
        if (formattedCompare) {
          el.textContent = formattedCompare;
          el.style.display = '';
        }
      });
    }

    bundles.forEach(function(bundle) {
      bundle.addEventListener('click', function() { selectBundle(bundle); });
    });

    // Sync initial price to whichever bundle starts active
    var activeBundle = document.querySelector('[data-cm-bundle].is-active');
    if (activeBundle) selectBundle(activeBundle);
  }

  /* ===================
     COLOR SWATCHES
     =================== */
  function initSwatches() {
    const swatches = document.querySelectorAll('[data-cm-swatch]');
    if (!swatches.length) return;

    swatches.forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        // Update active swatch
        swatches.forEach(function(s) { s.classList.remove('is-active'); });
        swatch.classList.add('is-active');

        // Update swatch labels
        var allLabels = document.querySelectorAll('[data-cm-swatch-label]');
        allLabels.forEach(function(lbl) { lbl.classList.remove('is-active'); });
        var colorName = swatch.getAttribute('data-cm-swatch');
        var matchLabel = document.querySelector('[data-cm-swatch-label="' + colorName + '"]');
        if (matchLabel) matchLabel.classList.add('is-active');

        // Update color name display
        document.querySelectorAll('[data-cm-color-name]').forEach(function(el) {
          el.textContent = colorName;
        });

        // Update variant inputs (only non-sticky forms — sticky CTA stays on variant.first)
        var variantId = swatch.getAttribute('data-variant-id');
        if (variantId) {
          var stickyForm = document.querySelector('[data-cm-sticky-cta] [data-cm-variant-input]');
          document.querySelectorAll('[data-cm-variant-input]').forEach(function(input) {
            // Don't update the sticky CTA's hidden input
            if (input !== stickyForm) {
              input.value = variantId;
            }
          });
        }
      });
    });
  }

  /* ===================
     STICKY CTA
     =================== */
  function initStickyCTA() {
    const sticky = document.querySelector('[data-cm-sticky-cta]');
    if (!sticky) return;

    var triggerEl = document.querySelector('[data-cm-real-reason]');
    if (!triggerEl) {
      // Fallback: don't show until user scrolls far enough
      sticky.classList.add('is-visible');
      return;
    }

    var shown = false;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        // Show sticky CTA once user scrolls past the Real Reason section
        if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
          shown = true;
          sticky.classList.add('is-visible');
        } else if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
          shown = false;
          sticky.classList.remove('is-visible');
        }
      });
    }, { threshold: 0 });

    observer.observe(triggerEl);
  }

  /* ===================
     ADD TO CART (AJAX)
     =================== */
  function initAddToCart() {
    document.querySelectorAll('[data-cm-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        const btn = form.querySelector('[data-cm-atc]');
        const variantInput = form.querySelector('[data-cm-variant-input]');
        if (!variantInput) return;

        const originalText = btn ? btn.innerHTML : '';
        if (btn) btn.innerHTML = '<span style="font-size:15px; font-weight:800; letter-spacing:0.02em; text-transform:uppercase;">Added To Cart ✓</span>';

        // Read quantity from the active bundle (set by selectBundle)
        var qty = parseInt(form.getAttribute('data-cm-quantity'), 10) || 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(variantInput.value, 10),
            quantity: qty
          })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          // Update cart count badge
          var badge = document.querySelector('[data-cm-cart-count]');
          if (badge) {
            fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
              badge.textContent = cart.item_count;
              badge.style.display = '';
            });
          }
          // Brief confirmation then redirect to cart page
          setTimeout(function() {
            window.location.href = '/cart';
          }, 800);
        })
        .catch(function() {
          if (btn) btn.innerHTML = originalText;
        });
      });
    });
  }

  /* ===================
     LAZY LOADING
     =================== */
  function initLazy() {
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-loaded');
            observer.unobserve(entry.target);
          }
        });
      }, { rootMargin: '100px' });

      document.querySelectorAll('.cm-lazy').forEach(function(el) {
        observer.observe(el);
      });
    } else {
      document.querySelectorAll('.cm-lazy').forEach(function(el) {
        el.classList.add('is-loaded');
      });
    }
  }

  /* ===================
     INIT ALL
     =================== */
  function init() {
    initCountdown();
    initGallery();
    initAccordions();
    initBundles();
    initSwatches();
    initStickyCTA();
    initAddToCart();
    initLazy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
